<template>
  <v-app theme="light">
    <slot/>
  </v-app>
</template>

<script setup lang="ts">
</script>